import styled from "styled-components";

export default styled.div`
  width: 100%;
  height: 44px;
  border-radius: 3px;
  background-color: #f7f8f9;

  :not(:last-child) {
    margin-bottom: 8px;
  }
`;
